module.exports = __webpack_public_path__ + "img/placeholder.a5796f43.png";